import NextLink from 'next/link'
import styled from 'styled-components'

export const StyledSpan = styled.span`
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  color: ${({ theme, color }) => theme.colors[color]};
  font-size: ${props => props.theme.fontSizes[props.fontSize]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};

  &:hover {
    text-decoration: none;
  }

  ${({ theme }) => theme.below.mobileXL`
    ${theme.getTypography('mobile', 'body', 'body2')}
  `}
`

export const CustomLink = styled(NextLink)`
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  color: ${({ theme, color }) => theme.colors[color]};
  font-size: ${({ theme, fontSize }) => theme.fontSizes[fontSize]}px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.below.mobileXL`
    ${theme.getTypography('mobile', 'body', 'body2')}
  `}
`
